(function () {
  'use strict';

  var CONTAINER_ID = 'ProductGridContainer';
  var GRID_ID = 'product-grid';
  var SENTINEL_ID = 'KwtInfiniteScrollSentinel';

  var observer = null;
  var loading = false;

  function injectStyles() {
    if (document.getElementById('KwtInfiniteScrollStyles')) return;
    var style = document.createElement('style');
    style.id = 'KwtInfiniteScrollStyles';
    style.textContent =
      /* Dawn hides any *:empty element (div:empty{display:none}) — the
         sentinel has no children by design, so it needs to be forced
         visible/laid-out here, otherwise IntersectionObserver never fires. */
      '#' + SENTINEL_ID + '{display:block !important;height:1px;}' +
      '.kwt-infinite-sentinel.is-loading{height:auto;padding:24px 0;text-align:center;font-size:14px;opacity:.7;}' +
      '.kwt-infinite-sentinel.is-loading::after{content:"Lädt weitere Unterkünfte …";}';
    document.head.appendChild(style);
  }

  function getContainer() {
    return document.getElementById(CONTAINER_ID);
  }

  function hidePagination(container) {
    var pag = container.querySelector('.pagination-wrapper');
    if (pag) pag.style.display = 'none';
  }

  function attachObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    var sentinel = document.getElementById(SENTINEL_ID);
    if (!sentinel) return;

    var container = getContainer();
    if (container) hidePagination(container);

    observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '600px 0px 600px 0px',
      threshold: 0
    });
    observer.observe(sentinel);
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        loadNextPage();
        break;
      }
    }
  }

  function loadNextPage() {
    var sentinel = document.getElementById(SENTINEL_ID);
    if (!sentinel || loading) return;

    var nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) {
      if (observer) observer.disconnect();
      return;
    }

    loading = true;
    sentinel.classList.add('is-loading');

    var sectionId = sentinel.getAttribute('data-section-id') || '';
    var sep = nextUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.getElementById(GRID_ID);
        var liveGrid = document.getElementById(GRID_ID);

        if (freshGrid && liveGrid) {
          var items = Array.prototype.slice.call(freshGrid.children);
          items.forEach(function (item) {
            liveGrid.appendChild(item);
          });
        }

        var freshSentinel = doc.getElementById(SENTINEL_ID);
        if (freshSentinel) {
          var newNext = freshSentinel.getAttribute('data-next-url') || '';
          sentinel.setAttribute('data-next-url', newNext);
          sentinel.setAttribute(
            'data-current-page',
            freshSentinel.getAttribute('data-current-page') || ''
          );
          if (!newNext && observer) observer.disconnect();
        } else if (observer) {
          observer.disconnect();
        }
      })
      .catch(function () {
        if (observer) observer.disconnect();
      })
      .finally(function () {
        loading = false;
        sentinel.classList.remove('is-loading');
      });
  }

  function init() {
    injectStyles();
    attachObserver();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();

    var container = getContainer();
    if (container) {
      // Re-attach whenever the grid section is replaced (e.g. by the
      // native sidebar facet filters, which do an AJAX section swap).
      var mo = new MutationObserver(function () {
        init();
      });
      mo.observe(container, { childList: true, subtree: false });
    }
  });
})();